import { Cartesian3, Color, ConstantPositionProperty, } from "cesium";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
export class ControlPoint {
    _sphere;
    _position;
    _ID;
    constructor(viewer, position, color = Color.FUCHSIA) {
        this._sphere = EarthBrainUtils.addSphere(viewer, position, color);
        this._position = position;
        this._ID = this._sphere.id;
    }
    set position(position) {
        this._position = position.clone();
        this._sphere.position = new ConstantPositionProperty(this._position);
    }
    get position() {
        return this._position.clone();
    }
    get ID() {
        return this._ID;
    }
    remove(viewer) {
        viewer.entities.removeById(this.ID);
        this._sphere = undefined;
        this._position = undefined;
    }
}
export class AIRoad {
    _connectingLine;
    _startPoint;
    _endPoint;
    _associatePointCloudId;
    constructor(viewer) {
        this._startPoint = undefined;
        this._endPoint = undefined;
        this._connectingLine = EarthBrainUtils.createLineEntity(viewer, "AIConnectingLine", [], {
            width: 3,
            color: Color.BLUE,
            outlineColor: Color.BLUE,
            outlineWidth: 1,
            clampToGround: false,
            epsilonGapBetWeenMeshAndPolyline: 0.1,
        });
    }
    get startPoint() {
        return this._startPoint.position;
    }
    get endPoint() {
        return this._endPoint.position;
    }
    set startPoint(position) {
        this._startPoint.position = position;
    }
    set endPoint(position) {
        this._endPoint.position = position;
    }
    get ID() {
        return this._connectingLine.id;
    }
    get associatePointCloudId() {
        return this._associatePointCloudId;
    }
    addControlPoint(viewer, position) {
        const controlPoint = new ControlPoint(viewer, position);
        if (!this._startPoint) {
            this._startPoint = controlPoint;
            this.update();
            return this._startPoint.ID;
        }
        if (this._startPoint && !this._endPoint) {
            this._endPoint = controlPoint;
            this.update();
            return this._endPoint.ID;
        }
        return undefined;
    }
    update() {
        //@ts-ignore
        this._connectingLine.polyline.positions =
            this._startPoint && this._endPoint
                ? [this.startPoint, this.endPoint]
                : [];
    }
    getLength() {
        return Cartesian3.distance(this.startPoint, this.endPoint);
    }
    getcontrolPointCount() {
        if (this._startPoint && this._endPoint) {
            return 2;
        }
        if (this._startPoint || this._endPoint) {
            return 1;
        }
        return 0;
    }
    _getControlPointWithID(id) {
        if (this._startPoint && this._startPoint.ID === id) {
            return this._startPoint;
        }
        if (this._endPoint && this._endPoint.ID === id) {
            return this._endPoint;
        }
        return undefined;
    }
    getControlPointIDAtIndex(index) {
        if (this._startPoint && this._endPoint) {
            if (index == 1) {
                return this._startPoint.ID;
            }
            if (index == 2) {
                return this._endPoint.ID;
            }
        }
        return undefined;
    }
    getControlPointPosition(id) {
        return this._getControlPointWithID(id).position.clone();
    }
    updateControlPointPosition(id, posiion) {
        this._getControlPointWithID(id).position = posiion;
        this.update();
    }
    removeControlPoint(viewer, id) {
        this._getControlPointWithID(id).remove(viewer);
        if (this._startPoint) {
            this._startPoint =
                this._startPoint.ID === id ? undefined : this._startPoint;
        }
        if (this._endPoint) {
            this._endPoint = this._endPoint.ID === id ? undefined : this._endPoint;
        }
        this.update();
    }
    remove(viewer) {
        viewer.entities.removeById(this.ID);
        this._startPoint && this._startPoint.remove(viewer);
        this._endPoint && this._endPoint.remove(viewer);
        this._startPoint = undefined;
        this._endPoint = undefined;
        this._connectingLine = undefined;
    }
    hasControlPoint(id) {
        return this._getControlPointWithID(id) !== undefined ? true : false;
    }
}
//# sourceMappingURL=ai-road.js.map